/**
 * CommentGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CommentGetReq
 */
export interface CommentGetReq {
  /** 评论ID，逗号分隔 */
  id: string
}

/**
 * CommentGetReq Schema
 */
export const CommentGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '评论ID，逗号分隔',
      format: 'string',
      type: 'string',
      label: '评论ID',
    },
  },
  required: ['id'],
  type: 'object',
}
